import ShareIcon from "@mui/icons-material/Share";
import { ShareMenu } from "@/app/(browse)/for-sale/details/[slug]/[id]/components/ShareMenu";
import PillButton from "../PillButton";
import EditIcon from "@mui/icons-material/Edit";
import Link from "next/link";
import PersonIcon from "@mui/icons-material/Person";
import IsAdmin from "@/auth/IsAdmin";
import { AdShareModel } from "@/app/(browse)/for-sale/details/[slug]/[id]/components/ShareList";
import { useLazySession } from "@/app/layout/useLazySession";
import { SaveButton } from "@/components/search/SaveButton";

function AdSaveAndShareButtons({
  ad,
  iconOnly,
  compactOnMobile,
}: {
  ad: AdShareModel;
  iconOnly?: boolean;
  compactOnMobile?: boolean;
}) {
  return (
    <>
      <ShareMenu
        ad={ad}
        target={
          <PillButton
            iconOnly={iconOnly}
            compactOnMobile={compactOnMobile}
            startIcon={<ShareIcon />}
          >
            {!iconOnly ? "Share" : null}
          </PillButton>
        }
      />
      <SaveButton
        type="AD"
        currentKey={ad.id}
        iconOnly={iconOnly}
        compactOnMobile={compactOnMobile}
      />
    </>
  );
}

export function AdActions({
  ad,
  iconOnly,
  compactOnMobile,
}: {
  ad: AdShareModel;
  iconOnly?: boolean;
  compactOnMobile?: boolean;
}) {
  const { session, isAuthenticated } = useLazySession();

  return (
    <>
      {isAuthenticated && IsAdmin(session?.user) && (
        <>
          <Link href={`/sell/ad/${ad.id}/details`}>
            <PillButton
              startIcon={<EditIcon />}
              iconOnly={iconOnly}
              compactOnMobile={compactOnMobile}
            >
              {!iconOnly ? "Edit" : null}
            </PillButton>
          </Link>
          <Link href={`/sell/dashboard/${ad.sellerId}`}>
            <PillButton
              startIcon={<PersonIcon />}
              iconOnly={iconOnly}
              compactOnMobile={compactOnMobile}
            >
              {!iconOnly ? "Dashboard" : null}
            </PillButton>
          </Link>
        </>
      )}
      <AdSaveAndShareButtons
        ad={ad}
        iconOnly={iconOnly}
        compactOnMobile={compactOnMobile}
      />
    </>
  );
}
